import type { CampaignDataLayer } from '~/helpers/datalayer/types'

/** Attribution applied to data layer events during a Braze-driven content action. */
export function useCampaignAttribution() {
  const campaign = useState<CampaignDataLayer | undefined>('braze-campaign-attribution', () => undefined)

  return {
    campaign,
    setCampaign: (value: CampaignDataLayer | null) => (campaign.value = value ?? undefined),
    clearCampaign: () => (campaign.value = undefined),
  }
}

const BRAZE_CAMPAIGN_KEYS = {
  name: 'braze_campaign_name',
  apiId: 'braze_campaign_api_id',
} as const

export const sanitizeCampaignText = (raw: unknown) => asString(raw)?.trim().slice(0, 200) ?? ''

/**
 * Reads a raw campaign property out of a Braze payload. Values arrive untyped from the
 * postMessage/SDK boundary, so every read is passed through `sanitizeCampaignText`.
 */
export type CampaignPropertyReader = (key: string) => unknown

export function readBrazeCampaign(
  get: CampaignPropertyReader,
  brazeContentType: CampaignDataLayer['brazeContentType'],
): CampaignDataLayer | null {
  const campaign = {
    brazeCampaignName: sanitizeCampaignText(get(BRAZE_CAMPAIGN_KEYS.name)),
    brazeCampaignApiId: sanitizeCampaignText(get(BRAZE_CAMPAIGN_KEYS.apiId)),
    brazeContentType,
  }
  return campaign.brazeCampaignName || campaign.brazeCampaignApiId ? campaign : null
}
